import axios from "axios";
import CryptoJS from "crypto-js";

import router from "@/router";
import keys from "@/config/keys";

export const SET_TOKEN = (state, token) => {
  axios.defaults.headers["Authorization"] = `Bearer ${token}`;
  state.token = token;
};

export const SET_USER = (state, user) => {
  state.user = user;
};

export const LOGIN_USER = (state, { access_token, expires_in }) => {
  const exp = 1000 * expires_in + Date.now();
  const token = CryptoJS.AES.encrypt(access_token, keys.CLIENT_SECRET);

  localStorage.setItem("token", token);
  localStorage.setItem("expiration", exp);
};

export const LOGOUT_USER = state => {
  axios.defaults.headers["Authorization"] = "";

  localStorage.removeItem("token");
  localStorage.removeItem("expiration");
  state.token = null;

  if (!window.location.search.includes("token")) {
    router.replace({
      name: "auth"
    });
  }

  state.user = null;
};
